var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content scrollbar"
  }, [_c('div', {
    staticClass: "whatCloudProxy"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("1. " + _vm._s(_vm.$t('setting.whatCloudProxy')))]), _c('img', {
    attrs: {
      "src": require("@/assets/img/cloudProxy.png"),
      "alt": "",
      "srcset": ""
    }
  }), _c('div', {
    staticClass: "txt",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("// " + _vm._s(_vm.$t('setting.restructed')))]), _c('div', {
    staticClass: "whatDescribe"
  }, [_vm._v(_vm._s(_vm.$t('setting.canEnableDescribe')))]), _c('div', {
    staticClass: "whatDescribe"
  }, [_vm._v(_vm._s(_vm.$t('setting.onPipSideDescribe')))])]), _c('div', {
    staticClass: "howEnableCloudProxy"
  }, [_c('div', {
    staticClass: "howEnableCloudProxyTitle"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("2. " + _vm._s(_vm.$t('setting.howEnableCloudProxy')))])]), _c('div', {
    staticClass: "stepOne"
  }, [_vm._v(_vm._s(_vm.$t('setting.stepONeDescribe')))]), _c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.$t('setting.cloudProxy')))]), _c('el-switch', {
    attrs: {
      "active-color": "#33AB4F",
      "inactive-color": "#9F9F9F"
    },
    on: {
      "change": _vm.changeCloudProxy
    },
    model: {
      value: _vm.cloudProxy,
      callback: function ($$v) {
        _vm.cloudProxy = $$v;
      },
      expression: "cloudProxy"
    }
  })], 1), _c('div', {
    staticClass: "stepTwo"
  }, [_vm._v(_vm._s(_vm.$t('setting.stepTwoDescribe')))]), _c('div', {
    staticClass: "proxyContent"
  }, [_c('div', {
    staticClass: "region"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('setting.receiverRegion')))]), _c('el-select', {
    attrs: {
      "popper-class": "cloudProxyOptions"
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  }, _vm._l(_vm.regionOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm._f("showRegions")(item.label),
        "value": item.value
      }
    });
  }), 1)], 1), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Linux")]), _c('div', {
    staticClass: "cloudContent"
  }, [_c('ul', {
    staticClass: "contentHead"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('setting.cloudProxyIpRange')))]), _c('li', [_vm._v(_vm._s(_vm.$t('setting.cloudProxyPort')))]), _c('li', [_vm._v(_vm._s(_vm.$t('setting.accessPointIpRange')))]), _c('li', [_vm._v(_vm._s(_vm.$t('setting.accessPort')))])]), _c('div', {
    staticClass: "contentBody"
  }, [_vm.value === '1' ? _c('div', {
    staticClass: "northAmerica"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3)]) : _vm.value === '2' ? _c('div', {
    staticClass: "europe"
  }, [_vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7)]) : _vm.value === '3' ? _c('div', {
    staticClass: "india"
  }, [_vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11)]) : _vm.value === '4' ? _c('div', {
    staticClass: "india"
  }, [_vm._m(12), _vm._m(13), _vm._m(14), _vm._m(15)]) : _vm.value === '5' ? _c('div', {
    staticClass: "southEastAsia"
  }, [_vm._m(16), _vm._m(17), _vm._m(18), _vm._m(19)]) : _vm._e(), _vm.value === '6' ? _c('div', {
    staticClass: "china"
  }, [_vm._m(20), _vm._m(21), _vm._m(22), _vm._m(23)]) : _vm._e()])]), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Web")]), _c('div', {
    staticClass: "cloudContent"
  }, [_c('ul', {
    staticClass: "contentHead"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('setting.cloudProxyIpRange')))]), _c('li', [_vm._v(_vm._s(_vm.$t('setting.cloudProxyPort')))]), _c('li', [_vm._v(_vm._s(_vm.$t('setting.accessPointIpRange')))]), _c('li', [_vm._v(_vm._s(_vm.$t('setting.accessPort')))])]), _c('div', {
    staticClass: "contentBody"
  }, [_vm.value === '1' ? _c('div', {
    staticClass: "northAmerica"
  }, [_vm._m(24), _vm._m(25), _vm._m(26), _vm._m(27)]) : _vm.value === '2' ? _c('div', {
    staticClass: "europe"
  }, [_vm._m(28), _vm._m(29), _vm._m(30), _vm._m(31)]) : _vm.value === '3' ? _c('div', {
    staticClass: "india"
  }, [_vm._m(32), _vm._m(33), _vm._m(34), _vm._m(35)]) : _vm.value === '4' ? _c('div', {
    staticClass: "india"
  }, [_vm._m(36), _vm._m(37), _vm._m(38), _vm._m(39)]) : _vm.value === '5' ? _c('div', {
    staticClass: "southEastAsia"
  }, [_vm._m(40), _vm._m(41), _vm._m(42), _vm._m(43)]) : _vm._e(), _vm.value === '6' ? _c('div', {
    staticClass: "china"
  }, [_vm._m(44), _vm._m(45), _vm._m(46), _vm._m(47)]) : _vm._e()])]), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Native")]), _c('div', {
    staticClass: "cloudContent"
  }, [_c('ul', {
    staticClass: "contentHead"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('setting.cloudProxyIpRange')))]), _c('li', [_vm._v(_vm._s(_vm.$t('setting.cloudProxyPort')))]), _c('li', [_vm._v(_vm._s(_vm.$t('setting.accessPointIpRange')))]), _c('li', [_vm._v(_vm._s(_vm.$t('setting.accessPort')))])]), _c('div', {
    staticClass: "contentBody"
  }, [_vm.value === '1' ? _c('div', {
    staticClass: "northAmerica"
  }, [_vm._m(48), _vm._m(49), _vm._m(50), _vm._m(51)]) : _vm.value === '2' ? _c('div', {
    staticClass: "europe"
  }, [_vm._m(52), _vm._m(53), _vm._m(54), _vm._m(55)]) : _vm.value === '3' ? _c('div', {
    staticClass: "india"
  }, [_vm._m(56), _vm._m(57), _vm._m(58), _vm._m(59)]) : _vm.value === '4' ? _c('div', {
    staticClass: "india"
  }, [_vm._m(60), _vm._m(61), _vm._m(62), _vm._m(63)]) : _vm.value === '5' ? _c('div', {
    staticClass: "southEastAsia"
  }, [_vm._m(64), _vm._m(65), _vm._m(66), _vm._m(67)]) : _vm._e(), _vm.value === '6' ? _c('div', {
    staticClass: "china"
  }, [_vm._m(68), _vm._m(69), _vm._m(70), _vm._m(71)]) : _vm._e()])])]), _c('div', {
    staticClass: "contactEmailContent"
  }, [_vm._v(_vm._s(_vm.$t('setting.contactEmailContent')))]), _c('div', {
    staticClass: "contactEmail"
  }, [_c('a', {
    staticStyle: {
      "color": "#017AFF !important"
    },
    attrs: {
      "href": "mailto:support@tvunetworks.com",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('setting.contactEmail')))])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("128.14.195.192/28")]), _c('li', [_vm._v("128.14.245.16/28")]), _c('li', [_vm._v("128.14.72.80/28")]), _c('li', [_vm._v("128.14.200.208/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600, 8001-8010")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 69.28.51.142 ")]), _c('li', [_vm._v("107.155.14.132")]), _c('li', [_vm._v("128.1.77.34")]), _c('li', [_vm._v("128.1.78.146")]), _c('li', [_vm._v("128.1.87.146")]), _c('li', [_vm._v("54.178.26.110")]), _c('li', [_vm._v("140.210.77.68")]), _c('li', [_vm._v("125.88.159.163")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" UDP: 8443 ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("104.166.160.208/28")]), _c('li', [_vm._v("23.236.110.32/28")]), _c('li', [_vm._v("104.166.142.134")]), _c('li', [_vm._v("104.166.161.4")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600, 8001-8010")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 69.28.51.142 ")]), _c('li', [_vm._v("107.155.14.132")]), _c('li', [_vm._v("128.1.77.34")]), _c('li', [_vm._v("128.1.78.146")]), _c('li', [_vm._v("128.1.87.146")]), _c('li', [_vm._v("54.178.26.110")]), _c('li', [_vm._v("140.210.77.68")]), _c('li', [_vm._v("125.88.159.163")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" UDP: 8443 ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("129.227.217.128/28")]), _c('li', [_vm._v("129.227.108.208/28")]), _c('li', [_vm._v("128.1.105.112/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600, 8001-8010")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 69.28.51.142 ")]), _c('li', [_vm._v("107.155.14.132")]), _c('li', [_vm._v("128.1.77.34")]), _c('li', [_vm._v("128.1.78.146")]), _c('li', [_vm._v("128.1.87.146")]), _c('li', [_vm._v("54.178.26.110")]), _c('li', [_vm._v("140.210.77.68")]), _c('li', [_vm._v("125.88.159.163")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" UDP: 8443 ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("129.227.113.112/28")]), _c('li', [_vm._v("129.227.55.96/28")]), _c('li', [_vm._v("122.10.153.74")]), _c('li', [_vm._v("129.227.234.123")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600, 8001-8010")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 69.28.51.142 ")]), _c('li', [_vm._v("107.155.14.132")]), _c('li', [_vm._v("128.1.77.34")]), _c('li', [_vm._v("128.1.78.146")]), _c('li', [_vm._v("128.1.87.146")]), _c('li', [_vm._v("54.178.26.110")]), _c('li', [_vm._v("140.210.77.68")]), _c('li', [_vm._v("125.88.159.163")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" UDP: 8443 ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("128.1.186.240/28")]), _c('li', [_vm._v("129.227.73.32/28")]), _c('li', [_vm._v("103.193.127.208/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600, 8001-8010")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 69.28.51.142 ")]), _c('li', [_vm._v("107.155.14.132")]), _c('li', [_vm._v("128.1.77.34")]), _c('li', [_vm._v("128.1.78.146")]), _c('li', [_vm._v("128.1.87.146")]), _c('li', [_vm._v("54.178.26.110")]), _c('li', [_vm._v("140.210.77.68")]), _c('li', [_vm._v("125.88.159.163")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" UDP: 8443 ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("14.29.38.144/28")]), _c('li', [_vm._v(" 27.45.161.144/28")]), _c('li', [_vm._v("183.232.200.144/28")]), _c('li', [_vm._v(" 115.238.206.0/28")]), _c('li', [_vm._v("106.3.209.0/28")]), _c('li', [_vm._v("112.13.216.0/28")]), _c('li', [_vm._v("219.153.111.128/28")]), _c('li', [_vm._v("221.178.42.0/28")]), _c('li', [_vm._v("113.207.12.0/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600, 8001-8010")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 69.28.51.142 ")]), _c('li', [_vm._v("107.155.14.132")]), _c('li', [_vm._v("128.1.77.34")]), _c('li', [_vm._v("128.1.78.146")]), _c('li', [_vm._v("128.1.87.146")]), _c('li', [_vm._v("54.178.26.110")]), _c('li', [_vm._v("140.210.77.68")]), _c('li', [_vm._v("125.88.159.163")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" UDP: 8443 ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("128.14.195.192/28")]), _c('li', [_vm._v("128.14.245.16/28")]), _c('li', [_vm._v("128.14.72.80/28")]), _c('li', [_vm._v("128.14.200.208/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 47.252.17.251 ")]), _c('li', [_vm._v("170.106.135.177")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("104.166.160.208/28")]), _c('li', [_vm._v("23.236.110.32/28")]), _c('li', [_vm._v("148.153.25.148")]), _c('li', [_vm._v("148.153.25.147")]), _c('li', [_vm._v("148.153.25.146")]), _c('li', [_vm._v("148.153.25.184")]), _c('li', [_vm._v("148.153.93.19")]), _c('li', [_vm._v("148.153.93.24")]), _c('li', [_vm._v("148.153.93.25")]), _c('li', [_vm._v("148.153.93.27")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 47.254.149.145 ")]), _c('li', [_vm._v("162.62.220.8")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("129.227.217.128/28")]), _c('li', [_vm._v("129.227.108.208/28")]), _c('li', [_vm._v("128.1.105.112/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 147.139.34.215 ")]), _c('li', [_vm._v("129.226.26.104")]), _c('li', [_vm._v("161.117.177.218")]), _c('li', [_vm._v("104.250.52.195")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("129.227.113.112/28")]), _c('li', [_vm._v("129.227.55.96/28")]), _c('li', [_vm._v("164.52.24.41")]), _c('li', [_vm._v("164.52.24.44")]), _c('li', [_vm._v("164.52.24.43")]), _c('li', [_vm._v("103.101.125.26")]), _c('li', [_vm._v("103.101.125.20")]), _c('li', [_vm._v("103.101.125.22")]), _c('li', [_vm._v("122.10.153.90")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 47.245.7.250 ")]), _c('li', [_vm._v("43.128.248.97")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("128.1.186.240/28")]), _c('li', [_vm._v("129.227.73.32/28")]), _c('li', [_vm._v("103.193.127.208/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 161.117.177.218 ")]), _c('li', [_vm._v("104.250.52.195")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("14.29.38.144/28")]), _c('li', [_vm._v(" 27.45.161.144/28")]), _c('li', [_vm._v("183.232.200.144/28")]), _c('li', [_vm._v(" 115.238.206.0/28")]), _c('li', [_vm._v("106.3.209.0/28")]), _c('li', [_vm._v("112.13.216.0/28")]), _c('li', [_vm._v("219.153.111.128/28")]), _c('li', [_vm._v("221.178.42.0/28")]), _c('li', [_vm._v("113.207.12.0/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 139.196.42.124 ")]), _c('li', [_vm._v("123.56.57.206")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 443")]), _c('li', [_vm._v("TCP: 443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("128.14.195.192/28")]), _c('li', [_vm._v("128.14.245.16/28")]), _c('li', [_vm._v("128.14.72.80/28")]), _c('li', [_vm._v("128.14.200.208/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 52.54.85.111 ")]), _c('li', [_vm._v("184.72.18.217")]), _c('li', [_vm._v("184.72.16.87")]), _c('li', [_vm._v("35.168.106.53")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("104.166.160.208/28")]), _c('li', [_vm._v("23.236.110.32/28")]), _c('li', [_vm._v("104.166.142.134")]), _c('li', [_vm._v("104.166.161.4")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 52.28.239.238 ")]), _c('li', [_vm._v("3.9.120.239")]), _c('li', [_vm._v("35.156.231.150")]), _c('li', [_vm._v("15.237.134.178")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("129.227.217.128/28")]), _c('li', [_vm._v("129.227.108.208/28")]), _c('li', [_vm._v("128.1.105.112/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 3.109.116.108 ")]), _c('li', [_vm._v("20.193.241.143")]), _c('li', [_vm._v("15.206.47.129")]), _c('li', [_vm._v("13.127.149.196")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("129.227.113.112/28")]), _c('li', [_vm._v("129.227.55.96/28")]), _c('li', [_vm._v("122.10.153.74")]), _c('li', [_vm._v("129.227.234.123")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 168.138.214.216 ")]), _c('li', [_vm._v("18.176.162.64")]), _c('li', [_vm._v("54.178.26.110")]), _c('li', [_vm._v("52.211.23.86")]), _c('li', [_vm._v("13.230.60.35")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("128.1.186.240/28")]), _c('li', [_vm._v("129.227.73.32/28")]), _c('li', [_vm._v("103.193.127.208/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 13.250.89.184 ")]), _c('li', [_vm._v("18.176.162.64")]), _c('li', [_vm._v("54.178.26.110")]), _c('li', [_vm._v("52.221.23.86")]), _c('li', [_vm._v("13.230.60.35")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("14.29.38.144/28")]), _c('li', [_vm._v(" 27.45.161.144/28")]), _c('li', [_vm._v("183.232.200.144/28")]), _c('li', [_vm._v(" 115.238.206.0/28")]), _c('li', [_vm._v("106.3.209.0/28")]), _c('li', [_vm._v("112.13.216.0/28")]), _c('li', [_vm._v("219.153.111.128/28")]), _c('li', [_vm._v("221.178.42.0/28")]), _c('li', [_vm._v("113.207.12.0/28")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v(" 101.132.108.165 ")]), _c('li', [_vm._v("123.56.235.221")]), _c('li', [_vm._v("106.14.12.130")]), _c('li', [_vm._v("118.190.148.38")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ul', [_c('li', [_vm._v("UDP: 4590-4600")]), _c('li', [_vm._v("UDP: 8001-8010")]), _c('li', [_vm._v("TCP: 443")]), _c('li', [_vm._v("UDP: 8443")])]);
}];
export { render, staticRenderFns };